import { GatsbyImage, getImage } from "gatsby-plugin-image"
import React from "react"

function MetaPost({ blogAuthor, date }) {
    const avatar = blogAuthor?.frontmatter?.avatar
    const authorName = blogAuthor?.frontmatter?.authorName
    return (
        <div className="author-header mb-10 ml-4 flex flex-row">
            <div className="h-[46px] w-[46px] rounded-full">
                {avatar && <GatsbyImage
                    className="h-[46px] w-[46px] rounded-full object-cover"
                    alt="author-mobile"
                    image={getImage(avatar)}
                />}
            </div>
            <div className="ml-2 flex flex-col sm:flex-row">
                <p className="text-sm leading-4 sm:text-[18px] sm:leading-9 ">
                    By{" "}
                    <strong>
                        {authorName}
                        {","}
                    </strong>
                </p>
                <p className="text-[12px] leading-4 text-[#9C9C9C] sm:ml-1 sm:text-[18px] sm:leading-9 sm:text-black">
                    {date}
                </p>
            </div>
        </div>
    )
}

export default MetaPost
